import { render } from "./SkeletonLoader.vue?vue&type=template&id=3064763c&scoped=true"
const script = {}

import "./SkeletonLoader.vue?vue&type=style&index=0&id=3064763c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3064763c"]])

export default __exports__